import axiosClient from "./axiosClient";

const studiesService = {
  create: (data) => axiosClient.post("/studies/", data),
  update: (id, data) => axiosClient.put(`/studies/${id}`, data),
  delete: (id) => axiosClient.delete(`/studies/${id}`),
  getMine: () => axiosClient.get("/studies/mine"),
  getOwn: () => axiosClient.get("/studies/owner"),
  getAll: () => axiosClient.get("/studies/all"),
  getById: (id) => axiosClient.get(`/studies/${id}`),
};

export default studiesService;
